import React from 'react'
import {Slide, SlideProps} from '@mui/material'

export const SlideUp = React.forwardRef((props: Exclude<SlideProps, 'direction'>, ref: React.Ref<unknown>) => (
    <Slide direction="up" {...props} ref={ref} />
))
